// Patch notes — the in-app changelog, newest first.
//
// Extracted from src/constants.ts (plans/monolith-migration-plan.md §11.12, Batch 1).
// This is CONTENT, not logic: 82 releases of user-facing changelog text. Keeping it in
// constants.ts forced every reader of the constants module to scroll past ~1,970 lines
// of prose to reach the helpers, and it dominated the file's size.
//
// constants.ts re-exports this unchanged, so every existing import keeps working.

export const PATCH_NOTES = [
  {
    version: "v1.9.6",
    date: "01. November 2026",
    title: "Dienstplan-Notizen, Nachtschichten, HR-Redesign",
    changes: [
      {
        type: "feature",
        text: "Dienstplan: Notizen mit Benutzerfarben, Notiz-Symbol auf Schichtbalken, klickbare Balken und Multi-Select-Team-Auswahl im Tagesraster"
      },
      {
        type: "feature",
        text: "Dienstplan: Rufbereitschaften als 24h-Raster mit klickbaren Fortsetzungen, Feiertage je Bundesland"
      },
      {
        type: "feature",
        text: "Zeiterfassung: zweistufige Korrektur, Admin-Stift auf jedem Datum, Überstunden-Auszahlung mit Schwellenwarnung und Echtzeit-Abgleich"
      },
      {
        type: "improvement",
        text: "Dienstplan-Oberfläche: Mitarbeiterfilter mit Suche, einheitliche Toolbar, kompakte Modals, laufende Schichten mit Bulk-Löschen"
      },
      {
        type: "bug",
        text: "Dienstplan-Fixes: Kalender füllt Höhe und Breite, Modal-Datum ist heute, Fehler beim Anlegen von Mitarbeitern"
      },
      {
        type: "improvement",
        text: "Automation & Qualität: Bucher-E-Mail wird bei Voucher-Rate tripz auf den Hauptgast kopiert; Backend-Verifikations-Toolchain verbessert um Bugs zu minimieren"
      }
    ]
  },
  {
    version: "v1.9.5",
    date: "29. Oktober 2026",
    title: "Chat-Upgrade, Housekeeping-Liste, Reporting-Redesign",
    changes: [
      {
        type: "improvement",
        text: "Chat: Formatierung, @-Erwähnungen in Gruppen, Link-Vorschau, Bildergalerie mit Zoom und Lesebestätigungen"
      },
      {
        type: "improvement",
        text: "Chat: Stummschaltung mit Zeitfenstern, Offline-Versand mit Auto-Retry, Kamera-Schnellauslöser, Wisch-Antwort und Sprung zum Ende"
      },
      {
        type: "bug",
        text: "Housekeeping: gedruckte Liste wieder als ausgerichtete Tabelle mit eigener Bemerkungs-Spalte und farbigen Zustands- und Status-Badges"
      },
      {
        type: "bug",
        text: "Housekeeping: Karten-Layout auf Laptops und schmalen Displays korrigiert; abgeschnittene Kopfzeile behoben"
      },
      {
        type: "improvement",
        text: "Reporting: Überarbeitete Seite mit kompakten KPI-Karten, konsolidierten Diagrammen und begrenztem Tooltip"
      },
      {
        type: "improvement",
        text: "UI & Sicherheit: Zentrale Seitentitel, einheitliche Abstände, neue Tabs; wöchentlicher Dependency-Scan und echter ZAP-Gate in CI"
      }
    ]
  },
  {
    version: "v1.9.4",
    date: "28. Oktober 2026",
    title: "Folio-Ansicht, Workflow-Erinnerungen, Dienstplan-Fixes",
    changes: [
      {
        type: "feature",
        text: "Folio: mehrere Folios nebeneinander, Routings, Debitor-Details und Umbuchen von Positionen im Apaleo-Stil"
      },
      {
        type: "feature",
        text: "Workflows: tägliche E-Mail-Erinnerung für offene Traces; Betreff, Text und Empfänger frei einstellbar"
      },
      {
        type: "improvement",
        text: "Workflows: Sales und Rezeption dürfen Regeln anlegen"
      },
      {
        type: "improvement",
        text: "Dienstplan: Rechtsklick-Menü auf Schichten"
      },
      {
        type: "bug",
        text: "Dienstplan: Bearbeiten einer Schicht ändert nun die Zelle statt eine Dublette anzulegen"
      },
      {
        type: "bug",
        text: "PWA: App lädt nach einem Deploy kein veraltetes HTML mehr und erholt sich selbst von veralteten Dateien"
      },
      {
        type: "bug",
        text: "Fix: fehlende Rechte-Ansprüche aus dem Token; nur stornierte Housekeeping-Traces werden ausgeblendet"
      }
    ]
  },
  {
    version: "v1.9.3",
    date: "23. Oktober 2026",
    title: "Traces-Verknüpfung, HR-Mehrfach-Bearbeitung, Sales-CRM-Automatik",
    changes: [
      {
        type: "feature",
        text: "Traces/Wartungen: Wartungsfenster sind jetzt mit Traces verknüpft (Änderungen laufen automatisch mit)"
      },
      {
        type: "feature",
        text: "Dienstplan & HR: Mehrfach-Bearbeitung überträgt nur geänderte Felder; Team-Übersicht-Spalten sortierbar"
      },
      {
        type: "improvement",
        text: "Sales-CRM: Angebot-Aktivität setzt die Firma automatisch in die Angebots-Phase; KPI-Kachel zählt nur fällige Wiedervorlagen; kompaktere Filter-Pills, Firmenverträge-Liste einheitlich formatiert"
      },
      {
        type: "bug",
        text: "Fix: Veraltete Rollenansprüche korrigieren sich automatisch; fehlende Standort-Pills sollten wieder funktionieren"
      },
      {
        type: "improvement",
        text: "Interne Ressourcen: Zimmercheck-Intervall pro Haus einstellbar"
      },
      {
        type: "improvement",
        text: "Haustechnik: zwei Untertabs in Haustechnik ausgeblendet"
      },
      {
        type: "improvement",
        text: "Anhänge öffnen sich im In-App-Viewer; Fundsachen zeigen Bildvorschauen; Fixes: iOS-Zoom im Chat, korrigierte Übersetzungen, Reservierungs-Tabelle mit mehr Höhe; Admin-Dashboard zeigt Menü-Nutzung"
      }
    ]
  },
  {
    version: "v1.9.2",
    date: "21. Oktober 2026",
    title: "Neuer Kalender-Dienstplan, Gastportal, E-Mail-Scans",
    changes: [
      {
        type: "feature",
        text: "Dienstplan: Neuer Kalender ersetzt die Schichten-Tabelle — Tag/Woche/Monat-Ansichten, Verschieben und Skalieren per Drag & Drop, Vorlagen und Bulk-Planung"
      },
      {
        type: "improvement",
        text: "HR: Arbeitsorte pro Mitarbeiter mit Standort-Filter im Kalender; Mitarbeiterdaten-Dialog mit Wochenstunden und Mehrfach-Bearbeitung"
      },
      {
        type: "improvement",
        text: "Reservierungen: Globale Suche durchsucht jetzt den kompletten Verlauf inklusive E-Mails und Firmen"
      },
      {
        type: "improvement",
        text: "Chat: Man kann nun mehrere Anhänge im Chat gleichzeitig schicken"
      },
      {
        type: "bug",
        text: "Fixes: Sperrapartments zeigen Prüftermine und Ap.-Nr., Anleitungen-Ordner lassen sich wieder anlegen, Reinigungsliste füllt Standorte wieder, Chat bleibt beim Laden unten"
      }
    ]
  },
  {
    version: "v1.9.1",
    date: "16. Oktober 2026",
    title: "Umsatz-Aufschlüsselung, Chat-Verlauf und -Suche, Business-Club",
    changes: [
      {
        type: "improvement",
        text: "Umsatz: Rechnungs-Aufschlüsselung pro Firma inkl. Vorausrechnungen, mit Warnhinweis bei übersprungenen Monaten"
      },
      {
        type: "improvement",
        text: "Sales: Firmenumsatz-Suchergebnisse und BusinessClub haben jetzt beide Summenanzeigen für Umsatz und Roomnights"
      },
      {
        type: "improvement",
        text: "Chat: ältere Nachrichten nachladen, gesamten Verlauf durchsuchen und Gruppen umbenennen"
      },
      {
        type: "improvement",
        text: "Business Club: Website-Quellen-Badge; Vom Websiteformular übermittelte Standorte und Nachrichten werden übernommen"
      },
      {
        type: "feature",
        text: "Interne Ressourcen: Neues Menü mit der Möglichkeit beliebige Checklisten zu erstellen mit verschiedenen Intervallen und Unterreiter für Sperrapartments"
      },
      {
        type: "bug",
        text: "Chat: Ansicht bleibt nun beim Öffnen von Anhängen unten verankert"
      },
      {
        type: "bug",
        text: "PWA: App lädt nach veraltetem Zwischenspeicher zuverlässig neu statt mit Ladefehler"
      }
    ]
  },
  {
    version: "v1.9.0",
    date: "15. Oktober 2026",
    title: "Kassenbuch-Sammel-Download, Lagerorte, Mobile-Polish",
    changes: [
      {
        type: "feature",
        text: "Kassenbuch: Sammel-Download aller Belege als ZIP, gefiltert nach Standort und Zeitraum"
      },
      {
        type: "improvement",
        text: "Inventarverwaltung: Lagerorte mit Mehrfach-Zuordnung und Badges"
      },
      {
        type: "improvement",
        text: "Oberfläche: Support-Bereich im Dark Mode-Design überarbeitet; Reservierungsdetails haben nun ID-Kopier-Buttons; Sidebar-Tabs per Drag-and-Drop sortierbar; Reservierungen können nun direkt aus der Pickup-Liste geöffnet werden"
      },
      {
        type: "bug",
        text: "Zimmerplan: Mobile Touch-Scroll, Details nun per Doppel-Tap und Wartungsfenster-Menü repariert"
      },
      {
        type: "bug",
        text: "Chat: Entwürfe pro Chat, getrennte Tipp-Indikatoren"
      }
    ]
  },
  {
    version: "v1.8.9",
    date: "13. Oktober 2026",
    title: "Zimmerwechsel-Bestätigung, Chat- und Trace-Fixes",
    changes: [
      {
        type: "improvement",
        text: "Roomrack: Bestätigungsdialog bei Zimmerwechsel über Kategorie oder Kapazität"
      },
      {
        type: "improvement",
        text: "Chat: 300 neueste Nachrichten laden, Pinnen serverseitig gespeichert, Mobile-Drawer-Fixes"
      },
      {
        type: "bug",
        text: "Housekeeping: LCO-Abreisezeit — Punkteform wie 11.30 nicht mehr als Datum fehlgelesen"
      },
      {
        type: "bug",
        text: "Traces: Namenszuordnung exakt (kein Nachnamen-Matching), Schnellfilter setzen Filter zurück"
      },
      {
        type: "bug",
        text: "Dashboard: Team-on-Duty live, Logs-Suche repariert, HR-Mitarbeiter-Anlegen speichert wieder"
      }
    ]
  },
  {
    version: "v1.8.8",
    date: "09. Oktober 2026",
    title: "Chat-Ausstattung, Sales-CRM-Polish",
    changes: [
      {
        type: "feature",
        text: "Chat: Rich-Emoji-Reaktionen mit Suche und Kategorien, Bilder aus der Zwischenablage einfügen, Drag-and-Drop-Upload, Bildvorschau im Lightbox-Modus und Anhänge werden vor dem Senden angezeigt"
      },
      {
        type: "feature",
        text: "Chat: Filter-Tabs (Alle, Direkt, Teams) und Nachrichten anpinnen — für mich oder für alle"
      },
      {
        type: "feature",
        text: "Sales-CRM: Neues Kontakt-Import-Feature — Excel mit Kontakt A und Kontakt B einlesen, Firmenzuordnung mit Prüfhinweis"
      },
      {
        type: "improvement",
        text: "Sales-CRM: Kanban-Board überarbeitet — Spalten verschiebbar, synchronisierte horizontale Scrollleiste, überarbeitete Aktivitäts- und Profil-Formulare, Statusfilter"
      },
      {
        type: "improvement",
        text: "Chat: Verbesserte Padding-Abstände und Header-Tooltips"
      },
      {
        type: "fix",
        text: "Chat: Info-Button bei Gruppen wieder da — Mitgliedsliste im Gruppeninfo-Fenster, mit Aktionen: Direktnachricht starten, Mitglieder entfernen und Adminrechte vergeben (Ersteller/Admins können Mitglieder zu Admins ernennen oder herabstufen)"
      },
      {
        type: "feature",
        text: "Analytics > KPI-Entwicklungen: Im Monatsansicht-Chart lassen sich zwei Punkte anklicken — die Vergleichsansicht zeigt Umsatz und Zimmernächte beider Tage mit Differenz unter dem Graph"
      }
    ]
  },
  {
    version: "v1.8.7",
    date: "08. Oktober 2026",
    title: "Automatisierungen, Sales-CRM, HR-Teamübersicht",
    changes: [
      {
        type: "improvement",
        text: "Chat: Nachrichten weiterleiten — Weiterleiten-Button neben Antworten, mit Chat-Auswahl"
      },
      {
        type: "feature",
        text: "BusinessClub: Reservierungs-Statistiken pro Mitglied — Suche per E-Mail, Firma oder beides mit Zeitraum-Auswahl, sortierbaren Spalten (Reservierungen, Umsatz, Roomnights) und bearbeitbarem Anmeldedatum"
      },
      {
        type: "feature",
        text: "Ladebalken: Globaler Fortschrittsbalken bei großen Datenabrufen — echte Seiten-Nummerierung bei Reservierungen und Firmenumsatz, Laufzeit-Anzeige und Hinweis bei großen Datenmengen"
      },
      {
        type: "feature",
        text: "Automatisierungen: Neuer No-Code-Builder unter Workflows mit Trigger-Katalog und E-Mail-Aktion"
      },
      {
        type: "feature",
        text: "Sales: Neues CRM-Pipeline-Modul"
      },
      {
        type: "improvement",
        text: "HR: Teamübersicht als eigener Sub-Tab; Planner-Spalte und Dark-Mode behoben"
      },
      {
        type: "improvement",
        text: "Rechte: Dashboard-Tab für Operations und Buchhaltung; Team-Online-Widget erweitert"
      },
      {
        type: "improvement",
        text: "Oberfläche: Fenster mit Maus verschiebbar, Blur entfernt, Modal-Höhe begrenzt"
      },
      {
        type: "bug",
        text: "Housekeeping: Stay-overs verschwanden zeitweise vom Reinigungsplan — behoben"
      },
      {
        type: "bug",
        text: "KPI-Entwicklungen: Der laufende Monat zeigte nur die vergangenen Tage statt Ist-Daten plus Entwicklung (z. B. Oktober nur 7 Tage) — behoben"
      },
      {
        type: "improvement",
        text: "Housekeeping: Zeilen auf der Reinigungsliste zum Drucken auswählen — Häkchen pro Zeile, es werden nur die ausgewählten Zimmer gedruckt (ohne Auswahl: alle)"
      },
      {
        type: "bug",
        text: "Firmenverträge: Speichern meldete fälschlich einen Konflikt, Detail-Footer ragte aus dem Modal — behoben"
      }
    ]
  },
  {
    version: "v1.8.6",
    date: "02. Oktober 2026",
    title: "Chat-Redesign, Videoanhänge, Housekeeping-Notizen & Upload-Fortschritt",
    changes: [
      {
        type: "improvement",
        text: "Chat: Neues Design mit Nachrichtbearbeitung, Anpinnen, Suche, Reaktionen und Videoanhängen"
      },
      {
        type: "improvement",
        text: "Chat: Zahlreiche Mobile-Fixes — Schreibfeld bleibt fixiert, Emoji-Picker, Vollbild-Ansicht"
      },
      {
        type: "improvement",
        text: "Housekeeping: Eigenes Bemerkungsfeld pro Zimmer mit Druck-Support"
      },
      {
        type: "improvement",
        text: "Upload: Globaler Fortschritts-Chip für alle Uploads; Chat erlaubt bis zu 100 MB pro Datei"
      },
      {
        type: "bug",
        text: "Fixes: KPI-Monatswerte, Angebots-Links, Buchhaltung und Chat-Löschungen"
      },
      {
        type: "bug",
        text: "Reservierungen: LCO-Zeiten ohne Minuten („LCO bis 13 Uhr“) werden jetzt auch erkannt für den Vermerk auf der Reinigungsliste"
      },
      {
        type: "improvement",
        text: "City-Tax-Korrektur: Automatisierte Kommentare tragen jetzt Kürzel des auslösenden Mitarbeiters"
      },
      {
        type: "feature",
        text: "Housekeeping: Schnellfilter „Frei“ zeigt nur unbelegte Zimmer auf der Liste"
      },
      {
        type: "bug",
        text: "Angebote: Verfügbarkeits-Prüfung bei Gruppen-Block-Bestätigung"
      },
      {
        type: "improvement",
        text: "Angebote: Gesendete und abgelaufene Angebote lassen sich jetzt im Inhalt ändern und Gast kann auf dem Link das neue Angebot per Button neu laden"
      }
    ]
  },
  {
    version: "v1.8.5",
    date: "01. Oktober 2026",
    title: "Links zu Traces,  Aktivitätenfilter, Zimmernummer ändern",
    changes: [
      {
        type: "bug",
        text: "Traces: Links zu Traces (z. B. aus dem Benachrichtigungsverlauf) ließen sich nicht öffnen, wenn ein Abteilungsfilter aktiv war und der Trace zu einer anderen Abteilung gehörte. - behoben"
      },
      {
        type: "improvement",
        text: "Benachrichtigungen: Es wurden einklappbare Kategorie-Chips (Traces, Antworten, Fundsachen, Tickets, Storno, HR, Sonstiges) hinzugefügt, mit denen man die Ansicht des Verlaufs auf bestimmte Ereignistypen eingrenzen kann."
      },
      {
        type: "improvement",
        text: "Reservierungen: Die Schnellaktionen für CI & CO in der Reservierungstabelle sollten jetzt wieder funtkionieren. Außerdem kann man jetzt das Zimmer in der Reservierungstabelle (via Stift-Symbol) ändern."
      }
    ]
  },
  {
    version: "v1.8.4",
    date: "28. September 2026",
    title: "Umsatzentwicklung & Jahresübersicht, Zimmerfilter für Traces",
    changes: [
      {
        type: "feature",
        text: "Kennzahlen: Der Bereich 'KPI-Entwicklungen' zeigt jetzt eine Monatsansicht mit Umsatzentwicklung."
      },
      {
        type: "feature",
        text: "Kennzahlen: Neue Jahresübersicht, mit der man sich die Entwicklung jeder Kennzahl Jahr für Jahr im Detail durchklicken kann. Formeln für ausgerechnete Werte wurden überarbeitet."
      },
      {
        type: "improvement",
        text: "Kennzahlen: Im Entwicklungs-Diagramm erscheinen beim Überfahren mit der Maus jetzt Detailinfos."
      },
      {
        type: "improvement",
        text: "Kennzahlen: Tages- und Monatsvergleiche richten sich jetzt zuverlässig am letzten verfügbaren Tag aus, statt gelegentlich alte Werte anzuzeigen."
      },
      {
        type: "improvement",
        text: "Traces: Neuer Zimmerfilter - die Suche nach einer Zimmernummer findet hierdurch nur wirklich passende Zimmer."
      },
      {
        type: "improvement",
        text: "Sicherheits- und Stabilitätsverbesserungen im Hintergrund."
      }
    ]
  },
  {
    version: "v1.8.3",
    date: "24. September 2026",
    title: "Dunkelmodus, neues Einstellungen-Design & mehr Übersicht",
    changes: [
      {
        type: "feature",
        text: "Neu: Dunkelmodus für fast die gesamte App - per Knopf oben in der Kopfzeile umschaltbar."
      },
      {
        type: "improvement",
        text: "Dashboard: Widgets lassen sich jetzt per Rechtsklick verwalten und passen ihre Höhe automatisch an."
      },
      {
        type: "feature",
        text: "Einstellungen: Frisches Design, Menü-Gruppen leichter erstellen und ein Abmelde-Knopf im Profil."
      },
      {
        type: "feature",
        text: "Analytik: Kennzahlen zeigen Tagesvergleiche und Prognosen."
      },
      {
        type: "improvement",
        text: "Zeiterfassung: Urlaub wird automatisch angerechnet und merhmaliges Ein- und Ausstempeln wird richtig angezeigt."
      },
      {
        type: "bug",
        text: "Fixes: Standort-Auswahl lädt wieder, keine Fehler bei leeren Daten, Handy-Seitenleiste ohne Versatz."
      }
    ]
  },
  {
    version: "v1.8.2",
    date: "22. September 2026",
    title: "Neues Dashboard, Tickets & Sicherheits-Fixes",
    changes: [
      {
        type: "feature",
        text: "Das Dashboard ist neu aufgebaut: Jeder Mitarbeiter kann seine Kacheln jetzt per Maus verschieben und in der Größe anpassen. Neu sind ein Traces-Widget, Zeiterfassung, ein Housekeeping-Widget mit aktuellem Zimmerstatus sowie An- und Abreise-Übersichten ohne Limit - inklusive Zimmernummer und Hinweis auf nicht zugeteilte Zimmer. Die Schnellaktionen sind neu geordnet und farbig gekennzeichnet, der Standortfilter sitzt oben in der Kopfzeile, und die Übersichten verlinken direkt in die zugehörigen Bereiche. Außerdem: direkter Chat mit den Kollegen im Team-on-Duty-Widget und ein Suchfeld, mit dem man von überall direkt zu einer Reservierung springen kann."
      },
      {
        type: "improvement",
        text: "Neue Kategorie im Support-Ticket-Formular"
      },
      {
        type: "bug",
        text: "Fix: Die Ticketliste zeigte die neuesten Tickets nicht"
      },
      {
        type: "bug",
        text: "Fix: Apaleo-Verbindung bleibt stabil, auch bei Störungen"
      },
      {
        type: "bug",
        text: "Fix: Haustechnik lädt jetzt zuverlässig, auch ohne Standort"
      },
      {
        type: "improvement",
        text: "Sicherheitslücken im Hintergrund geschlossen"
      },
      {
        type: "bug",
        text: "Fix: Fundsachen - der Standort im Anlege-Formular wird jetzt zuverlässig geladen. Neue, bearbeitete oder gelöschte Einträge erscheinen sofort in der Liste, ohne die Seite neu zu laden."
      },
      {
        type: "bug",
        text: "Fix: Überbuchungs-Sperren und Warteliste aktualisieren ihre Listen jetzt sofort nach Speichern, Bearbeiten oder Löschen - ohne Modal neu zu öffnen. Änderungen des Reinigungstags im Gastprofil übertragen sich jetzt direkt in die Housekeeping-Ansicht."
      },
      {
        type: "bug",
        text: "Fix: Im Chat eines Traces lassen sich Kollegen jetzt wieder per @-Erwähnung anschreiben."
      },
      {
        type: "bug",
        text: "Fix: Traces - die Standort-Auswahl im Filter und beim Anlegen eines Traces zeigt die Standorte jetzt zuverlässig an."
      },
      {
        type: "bug",
        text: "Fix: Standort-Auswahlen und -Filter in der gesamten App werden jetzt zuverlässig geladen."
      },
      {
        type: "bug",
        text: "Fix: Fundsachen - beim Anlegen eines Eintrags wird der Standort jetzt auch dann angeboten, wenn die Standort-Liste erst kurz nach dem Öffnen des Formulars geladen wird."
      },
      {
        type: "improvement",
        text: "Man kann jetzt Angebote auf Englisch verschicken"
      },
      {
        type: "feature",
        text: "Reporting: Es gibt jetzt einen Unterreiter 'KPI-Entwicklungen'  mit täglichem Schnappschuss der Belegungsdaten um 6.30 Uhr"
      }
    ]
  },
  {
    version: "v1.8.1",
    date: "20. September 2026",
    title: "Diverse Verbesserungen",
    changes: [
      {
        type: "improvement",
        text: "Folio: Zahlung per Zahlungskonto - im Zahlungsdialog kann jetzt zwischen den klassischen Zahlungsarten und dem auf der Reservierung hinterlegten Zahlungskonto gewählt werden."
      },
      {
        type: "improvement",
        text: "Schichtübergabe: Der Ersteller kann seine eigene Übergabe jetzt abschließen, wenn kein Nachfolger benannt wurde. Außerdem lässt sich die Übergabeliste nach Standort filtern, und neue Übergaben werden direkt mit Standort angelegt."
      },
      {
        type: "improvement",
        text: "Schichtübergabe: Housekeeping und Hausdame sehen den Übergabe-Bereich jetzt im Menü und können Übergaben einsehen und bestätigen."
      },
      {
        type: "improvement",
        text: "Fundsachen: Beim Anlegen eines Fundsachen-Eintrags wird der Standort jetzt verpflichtend abgefragt - neue Einträge landen nicht mehr automatisch auf dem ersten Standort, und ein Eintrag ohne Standort kann nicht gespeichert werden."
      },
      {
        type: "improvement",
        text: "Gruppen: Zimmerblöcke (Kontingente) lassen sich jetzt direkt in der Gruppe bearbeiten - Anreise, Abreise, Zimmeranzahl und Tagesrate können angepasst und mit Apaleo synchronisiert werden. Rateplan und Zimmerkategorie bleiben aus technischen Gründen unveränderlich."
      },
      {
        type: "bug",
        text: "Zimmerplan: Kategorien hatten teils dieselbe Farbe - jetzt erhält jede Kategorie eine eigene, unterscheidbare Farbe."
      }
    ]
  },
  {
    version: "v1.8.0",
    date: "20. September 2026",
    title: "Reservierungen-Springen, Heatmaps & Sicherheits-Update",
    changes: [
      {
        type: "improvement",
        text: "Reservierungen: Neue Suchleiste 'Zur Reservierung springen (per ID)' - Reservierungs-ID eingeben und direkt zum Gastprofil springen, auch wenn die Reservierung nicht auf der aktuellen Seite sichtbar ist."
      },
      {
        type: "improvement",
        text: "Reservierungen: Die Liste zeigt jetzt externe Buchungs-IDs (OTA, GDS, Channel-Manager u.a.) und die Buchungsquelle, damit man nachvollziehen kann, über welchen Kanal eine Buchung kam."
      },
      {
        type: "feature",
        text: "Analytics: Neuer Unter-Reiter 'Heatmaps' mit zwei Auswertungen - Umsatz nach Woche und Wochentag sowie Buchungstempo & Vorlaufzeit (in welchen Zeiträumen und wie viele Wochen vor Anreise gebucht wird)."
      },
      {
        type: "feature",
        text: "Benachrichtigungen & Storno-Scan: Das Outlook-Postfach wird automatisch alle 30 Minuten auf Stornierungen geprüft - auch ältere Mails werden jetzt zuverlässig erfasst. Storno-Benachrichtigungen öffnen die zugehörige Reservierung direkt, und lange Meldungen lassen sich per Pfeil auf- und zuklappen."
      },
      {
        type: "improvement",
        text: "Reporting: In der Pick-Up-Spalte wird jetzt zusätzlich die Uhrzeit angezeigt (z.B. 21.09.2026 14:30), und die Sortierung erfolgt nach vollständigem Zeitstempel statt nur nach Datum."
      },
      {
        type: "improvement",
        text: "Geschwindigkeit: Umfassende Optimierung der Ladezeiten im Dashboard, in Reservierungen, Housekeeping, HR und weiteren Bereichen durch effizientere Datenabfragen und schnellere Schnittstellen."
      },
      {
        type: "bug",
        text: "Stabilität: Behoben - die Housekeeping-Ansicht lud auf einzelnen Geräten endlos neu; in der Analytics-Ansicht überschrieben sich Datumsfilter gegenseitig, sodass Voreinstellungen nur einen Teil der Filter aktualisierten; der Storno-Scan übersprang zeitweise bereits geprüfte Mails."
      },
      {
        type: "improvement",
        text: "Sicherheits-Update: Umfassende Überprüfung der gesamten Plattform mit 18 behobenen Schwachstellen - u.a. verschärfter Schutz für Gastdaten, automatische Abwehr zu häufiger Anmeldeversuche und Absicherung automatisierter Buchungsübernahmen."
      }
    ]
  },
  {
    version: "v1.7.9",
    date: "18. September 2026",
    title: "Reservierungen bearbeiten, Late Check-out & Chat-Uhrzeiten",
    changes: [
      {
        type: "improvement",
        text: "Gastprofil: Kommentare, Folio und gebuchte Zusatzleistungen einer Reservierung können jetzt direkt bearbeitet werden - die Änderungen werden mit Apaleo synchronisiert."
      },
      {
        type: "feature",
        text: "Late Check-out: Neue Schnellaktion in den Reservierungen. Vor der Buchung erscheinen Dienstleistung und Preis zur Bestätigung, und Housekeeping sieht einen violetten LCO-Hinweis auf der Reinigungsliste."
      },
      {
        type: "improvement",
        text: "Chat: Nachrichten zeigen jetzt Uhrzeiten (heute, gestern oder Datum), und der Menüpunkt zeigt die Anzahl ungelesener Nachrichten als Zahl statt nur eines Punkts."
      },
      {
        type: "bug",
        text: "Navigation: Menügruppen lassen sich jetzt wieder korrekt auf- und zuklappen, und der Zustand bleibt auch nach dem Neuladen erhalten."
      }
    ]
  },
  {
    version: "v1.7.8",
    date: "17. September 2026",
    title: "Chat-Verbesserungen & Fehler-Behebungen",
    changes: [
      {
        type: "feature",
        text: "Zimmerplan: Bei Sperren (Seriensperrung und 'Wartungsfenster bearbeiten') gibt es jetzt Schnellauswahl-Buttons für die Beschreibungstexte RanT und SffA."
      },
      {
        type: "bug",
        text: "Chat: Diverse Verbesserungen und Fehler behoben"
      },
      {
        type: "bug",
        text: "Benachrichtigungen: Auf iPhone/iOS wurde nie nach der Berechtigung gefragt, dadurch kamen keine Push-Nachrichten an. Die Abfrage erscheint jetzt beim Tippen auf die Glocke."
      },
      {
        type: "bug",
        text: "Benachrichtigungen: Tippen auf eine Benachrichtigung öffnet jetzt den richtigen Chat bzw. den richtigen Trace, und pro Chat erscheint eine eigene Benachrichtigung statt einer einzigen, die immer ersetzt wurde."
      },
      {
        type: "bug",
        text: "Housekeeping: Im Forecast-Tab fehlten auf dem Handy der Datums- und der Standortfilter"
      },
      {
        type: "bug",
        text: "Angebote: In der Preiszusammenfassung wurden zwei verschiedene Beträge mit 'Gesamtpreis' bezeichnet. Der Netto-Betrag heißt jetzt 'Netto (ohne MwSt.)'."
      },
    ]
  },
  {
    version: "v1.7.7",
    date: "17. September 2026",
    title: "Neuer Chat & Dashboard/Reservierungen-Menü",
    changes: [
      {
        type: "feature",
        text: "Neues Chat-Menü (Beta-Version) - Traces, Angebote & Reservierungen können im Chat geteilt werden"
      },
      {
        type: "feature",
        text: "Reservierungen sind jetzt eigenes Menü (vom Dashboard losgelöst - auch Beta-Version)"
      },
      {
        type: "improvement",
        text: "Haustechnik-Projekt-Planer & mobile Ansicht verbessert"
      },
      {
        type: "bug",
        text: "Angebote zeigen jetzt Stornobedingungen korrekt"
      },
      {
        type: "bug",
        text: "Firmenverträge: Spalten- & Log-Fehler behoben"
      },
      {
        type: "bug",
        text: "Absturz durch kaputte Sidebar-Einstellung behoben"
      }
    ]
  },
  {
    version: "v1.7.6",
    date: "11. September 2026",
    title: "Haustechnik-Listen: Pagination & Mobile-Fix",
    changes: [
      {
        type: "improvement",
        text: "Haustechnik-Listen zeigen jetzt alle Einträge an: Die Listen wurden bisher bei 100 Einträgen abgeschnitten. Ab jetzt gibt es eine Seitennavigation (50 Einträge pro Seite) und Sortierungen funktionieren über alle Seiten hinweg."
      },
      {
        type: "bug",
        text: "Im Haustechnik-Menü wurde auf dem Handy die Tabelle der Listen nicht angezeigt, sobald die Listenauswahl zu lang war. Behoben."
      },
      {
        type: "bug",
        text: "Im Zimmercheck wurde statt des Hinweistextes ein Platzhalter im Eingabefeld für Audit-Notizen angezeigt. Behoben."
      },
      {
        type: "bug",
        text: "In der Firmen-Umsatzsuche im Salesmenü gab es eine Limitierung von max. 5000 Reservierungen, wodurch nicht alle Umsätze und Nächte gezählt wurden. Behoben."
      }
    ]
  },
  {
    version: "v1.7.5",
    date: "11. September 2026",
    title: "Fehler bei Dateiupload behoben",
    changes: [
      {
        type: "bug",
        text: "Fehler behoben beim Upload von Dateien, der durch Umlaute im Dateinamen verursacht wurde."
      }
    ]
  },
  {
    version: "v1.7.4",
    date: "10. September 2026",
    title: "Schichtübergabe, Kalender & Ordner-Upload",
    changes: [
      {
        type: "feature",
        text: "Neues Schichtübergabe-Menü für die Rezeption"
      },
      {
        type: "feature",
        text: "Verfügbarkeitskalender pro Standort als neues Menü"
      },
      {
        type: "improvement",
        text: "Zimmerzustand kann man jetzt direkt im Zimmerplan ändern"
      },
      {
        type: "feature",
        text: "Mehrere Ordner per Drag+Drop im Buchhaltungsmenü gleichzeitig hochladen"
      },
      {
        type: "bug",
        text: "Benachrichtigungen laden nicht mehr endlos"
      },
      {
        type: "bug",
        text: "Fehler bei Support-Tickets & Kassenbuch behoben"
      },
      {
        type: "improvement",
        text: "Automatisierungen & Sicherheit im Hintergrund"
      }
    ]
  },
  {
    version: "v1.7.3",
    date: "05. September 2026",
    title: "Ortstaxe & HRS-Aufteilung Kommentar",
    changes: [
      {
        type: "improvement",
        text: "Ortstaxe neu berechnen & HRS-Aufteilung hinterlassen jetzt einen Kommentar in der Reservierung, dammit andere Benutzer wissen, dass der Automatismus bereits benutzt wurde"
      }
    ]
  },
  {
    version: "v1.7.2",
    date: "03. September 2026",
    title: "Ortstaxe: Filter & HRS-Aufteilung",
    changes: [
      {
        type: "improvement",
        text: "Ortstaxe neu berechnen: Filter nach Buchungsquelle und Erstellungsdatum der Reservierung."
      },
      {
        type: "improvement",
        text: "HRS/Club-Rates aufteilen: Frühstück wird herausgerechnet und die Ortstaxe korrekt neu berechnet."
      },
      {
        type: "improvement",
        text: "Ergebnisliste der Ortstaxe zeigt jetzt den echten Buchungskanal (z.B. Booking.com)."
      }
    ]
  },
  {
    version: "v1.7.1",
    date: "03. September 2026",
    title: "Emojis, Buchhaltung & viele Reparaturen",
    changes: [
      {
        type: "feature",
        text: "Neuer Emoji-Picker mit Kürzeln in allen Chats."
      },
      {
        type: "improvement",
        text: "Buchhalter sehen jetzt auch XRechnung und mehr."
      },
      {
        type: "improvement",
        text: "Settlement-Abrechnungen zeigen jetzt die Batch-Nummer, Der Unter-Reiter 'Rechnungen' ist zurück & Der DATEV-Export wurde entfernt."
      },
      {
        type: "improvement",
        text: "Nach Updates lädt die App jetzt von selbst neu."
      },
      {
        type: "improvement",
        text: "Sicherheits- und Stabilitäts-Updates."
      },
      {
        type: "bug",
        text: "Fotos in Traces öffnen jetzt wieder zuverlässig."
      },
      {
        type: "bug",
        text: "Geänderte Fälligkeiten in Traces bleiben erhalten."
      },
      {
        type: "bug",
        text: "Benachrichtigungen aktualisieren sich sofort."
      },
      {
        type: "bug",
        text: "Auswahl-Menüs werden nicht mehr verdeckt."
      }
    ]
  },
  {
    version: "v1.7.0",
    date: "01. September 2026",
    title: "Folios in Reservierungsdetails",
    changes: [
      {
        type: "feature",
        text: "Es gibt jetzt ein neues Menü für Folios in den Reservierungsdetails"
      }
    ]
  },
  {
    version: "v1.6.9",
    date: "28. August 2026",
    title: "Buchhaltung: Summe Auszahlungsbetrag, mehr Rservierungsdetails & neues Explorer-Menü",
    changes: [
      {
        type: "improvement",
        text: "In der Buchhaltung unter Zahlungen/Abrechnungen wird jetzt unter der Tabelle automatisch die Summe aller Auszahlungsbeträge angezeigt"
      },
      {
        type: "feature",
        text: "In der Reservierungsliste gibt es jetzt Buttons für CI, CO und Stornierung von Reservierungen"
      },
      {
        type: "improvement",
        text: "In dem Gästeprofil unter Reservierungsdetails gibt es jetzt mehr Infos zu der Reservierung"
      },
      {
        type: "feature",
        text: "Es gibt jetzt ein neues Menü names 'Explorer', in dem man die gesamte App nach Suchwörtern durchsuchen kann"
      }
    ]
  },
  {
    version: "v1.6.8",
    date: "25. August 2026",
    title: "Traces, Live-Benutzer & Fehlerbehebungen",
    changes: [
      {
        type: "feature",
        text: "In Traces können jetzt mehrere Dateien gleichzeitig hochgeladen werden. Außerdem wird auf jeder Trace-Karte in Echtzeit die Anzahl der Kommentare angezeigt."
      },
      {
        type: "bug",
        text: "Der Upload-Pfad für Trace-Anhänge wurde korrigiert, sodass Dateien wieder zuverlässig gespeichert werden."
      },
      {
        type: "bug",
        text: "Der Speichern-Button in der Arbeitszeitkorrektur (Personalwesen) wurde repariert und ist jetzt wieder aktiv."
      },
      {
        type: "bug",
        text: "Die Pick-Up-Statistik verteilt jetzt Buchungen, die sich über mehrere Monate erstrecken, korrekt auf die jeweiligen Monate."
      },
      {
        type: "bug",
        text: "Ein Fehler bei der automatischen Wiederherstellung von Zustellbetten wurde behoben. Die Automatisierung funktioniert jetzt zuverlässiger."
      },
      {
        type: "bug",
        text: "Doppelte Kassenbucheinträge bei Buchungsänderungen werden jetzt automatisch verhindert."
      }
    ]
  },
  {
    version: "v1.6.7",
    date: "24. August 2026",
    title: "URL-Deep-Links, HR-Planer & Performance-Updates",
    changes: [
      {
        type: "feature",
        text: "URL-Deep-Links für alle Filter und Detailansichten: Filterzustände, geöffnete Modals und das Gästeprofil werden jetzt in der URL gespeichert. Seiten können so mit vollständigem Zustand als Lesezeichen gespeichert oder geteilt werden. Ein neuer \"Link kopieren\"-Button in der Kopfzeile erleichtert das Teilen für PWA-Nutzer."
      },
      {
        type: "feature",
        text: "Personalwesen-Planer wurde in die Unter-Tabs \"Abwesenheiten\" und \"Schichten\" aufgeteilt, mit einer neuen Abteilungs-Abdeckungsanzeige. Mitarbeiter können jetzt direkt in der Liste bearbeitet werden (Stunden pro Tag, Arbeitstage, Zielstunden) ohne den Umweg über separate Modals."
      },
      {
        type: "bug",
        text: "Arbeitszeitverlust durch Doppel-Einstempeln und Echtzeit-Zurücksetzungen im Personalwesen wurde behoben. Die Überstunden-Berechnung berücksichtigt jetzt korrekt die individuellen Arbeitstage und Zielstunden jedes Mitarbeiters."
      },
      {
        type: "bug",
        text: "Angebote wurden teilweise fälschlich als \"abgelaufen\" markiert und die Erstellung neuer Angebote war in bestimmten Fällen blockiert. Beide Probleme wurden behoben."
      },
      {
        type: "improvement",
        text: "Deutliche Performance-Verbesserungen in allen Ansichten: Filter und Eingabefelder reagieren spürbar schneller, der Personalwesen-Planer lädt große Datenmengen effizienter, und überflüssige API-Aufrufe im Housekeeping wurden entfernt."
      },
      {
        type: "bug",
        text: "Admin-Ticket-Antworten werden jetzt zuverlässig gespeichert und die @Erwähnung-Auswahlliste zeigt alle Benutzer mit gleichem Vornamen an (statt nur den ersten)."
      },
    ]
  },
  {
    version: "v1.6.6",
    date: "24. August 2026",
    title: "Antworten auf Chat-Nachrichten",
    changes: [
      {
        type: "feature",
        text: "In Chat-Ansichten (Traces, Fundsachen, Tickets) kann jetzt auf einzelne Nachrichten geantwortet werden. Die zitierte Nachricht wird oberhalb der Antwort angezeigt und per Klick scrollt die Ansicht zur ursprünglichen Nachricht."
      },
      {
        type: "feature",
        text: "Push-Benachrichtigung bei Antworten: Der Verfasser der ursprünglichen Nachricht erhält eine Push-Nachricht mit Vorschau der Antwort. Selbst-Antworten werden unterdrückt."
      },
    ]
  },
  {
    version: "v1.6.5",
    date: "6. August 2026",
    title: "Firmenverträge (Company Contracts)",
    changes: [
      {
        type: "feature",
        text: "Neues Verträge-Modul im Sales & Revenue-Bereich: Vollständige Verwaltung von Firmenverträgen mit sortier- und filterbarer Vertragsliste, Status-Badges und Massenaktionen (Archivieren, Löschen, Export)."
      },
      {
        type: "feature",
        text: "Excel-Import-Assistent: 5-Schritt-Wizard (Upload → Spaltenzuordnung → Validierung → Bestätigung → Ausführung) zum Import von Firmenraten mit automatischer Apaleo-Anbindung, zellengenauer Fehleranzeige und Wiederholung fehlgeschlagener Zeilen."
      },
      {
        type: "feature",
        text: "Ratenplan-Editor: Bearbeiten von verknüpften Apaleo-Ratenplänen mit Vorschau vor dem Push an Apaleo."
      },
      {
        type: "feature",
        text: "PDF-Upload mit Versionierung: Drag-and-Drop-Upload von Vertragsdokumenten (max. 25 MB) mit automatischer Versionierung bei gleichnamigen Dateien."
      },
      {
        type: "feature",
        text: "Excel-Export: Vertragsdaten inklusive aller verknüpften Ratenplan-Details als Excel-Datei exportieren."
      },
    ]
  },
  {
    version: "v1.6.4",
    date: "5. August 2026",
    title: "Fehler beim Anlegen von neuen Artikeln",
    changes: [
      {
        type: "bug",
        text: "Fehler beim Anlegen von neuen Artikeln wurde behoben"
      }
    ]
  },
  {
    version: "v1.6.3",
    date: "3. August 2026",
    title: "Personalwesen UI Update",
    changes: [
      {
        type: "improvement",
        text: "Das Personalwesen-Menü hat ein UI Update bekommen."
      }
    ]
  },
  {
    version: "v1.6.2",
    date: "24. Juli 2026",
    title: "Pick-Up Liste bei Gruppenmodul",
    changes: [
      {
        type: "improvement",
        text: "Im Gruppenmodul bei den Kontingenten gibt es jetzt die möglichkeit mehrere Reservierungen hintereinander zu machen wie in Apaleo"
      }
    ]
  },
  {
    version: "v1.6.1",
    date: "23. Juli 2026",
    title: "Zimmerplan-Ansicht Update",
    changes: [
      {
        type: "improvement",
        text: "Zimmerplan hat ein kleines Interface-Update bekommen und man kann den Plan jetzt während der Seriensperrung richtig sehen und bewegen."
      },
      {
        type: "bug",
        text: "Tickets zeigen jetzt den geschriebenen Text der Nachricht richtig an."
      },
      {
        type: "improvement",
        text: "Hausdamen dürfen jetzt auch im Zimmerplan-Menü Gästedetails ansehen."
      }
    ]
  },
  {
    version: "v1.6.0",
    date: "21. Juli 2026",
    title: "Ortstaxe neu berechnen (ChannelManager)",
    changes: [
      {
        type: "feature",
        text: "Neue Aktion im Reservierungen-Menü: 'Ortstaxe neu berechnen'. Der Gesamtbetrag der Reservierung bleibt unverändert."
      },
      {
        type: "feature",
        text: "Dry-Run-Modus standardmäßig aktiv: Vorschau aller betroffenen Reservierungen ohne API-Änderungen. Live-Run erfordert eine zweite, explizite Bestätigung."
      },
      {
        type: "improvement",
        text: "Idempotency-Key pro Nacht und Reservierung verhindert Doppelbuchungen bei Netzwerkfehlern oder wiederholten Klicks."
      },
      {
        type: "improvement",
        text: "Detailliertes Ergebnis-Panel mit Verarbeitet/Übersprungen/Fehler-Übersicht pro Reservierung inkl. Original- und neuem Gesamtbetrag."
      },
      {
        type: "improvement",
        text: "Globaler Audit-Log-Eintrag für jeden Lauf (Dry-Run & Live) mit Bediener, Zeitraum und Ergebnis-Countern."
      }
    ]
  },
  {
    version: "v1.5.9",
    date: "20. Juli 2026",
    title: "Drucken in Forecast & Filter werden jetzt gespeichert",
    changes: [
      {
        type: "improvement",
        text: "Forecast: Drucken-Button hinzugefügt"
      },
      {
        type: "improvement",
        text: "Filter werden jetzt gespeichert, wenn man in ein anderes Menu geht und dann wieder zurück"
      },
      {
        type: "improvement",
        text: "Bei Angeboten gibt es jetzt einen Cut-off-Datum bearbeiten Button. Wenn Gäste den Link öffnen wird dies auch automatisch aktualisiert."
      },
      {
        type: "bug",
        text: "Die Ablaufdaten von den Angeboten werden jetzt richtig in der Auflistung erkannt und markiert."
      }
    ]
  },
  {
    version: "v1.5.8",
    date: "16. Juli 2026",
    title: "Vielfaches Update",
    changes: [
      {
        type: "feature",
        text: "Automatischer Inaktivitäts-Logout: Benutzer werden nach 1 Stunde Inaktivität automatisch abgemeldet. 5 Minuten vorher erscheint eine Warnung."
      },
      {
        type: "improvement",
        text: "Multi-File-Upload für Support-Tickets: Mehrere Dateien können jetzt gleichzeitig an ein Support-Ticket angehängt werden."
      },
      {
        type: "improvement",
        text: "Bestätigungs-Pop-up für 'Erledigt': Der Schnellaktions-Button in der Traces-Liste fragt jetzt vor dem Markieren als erledigt nach."
      },
      {
        type: "improvement",
        text: "Mobile Layouts optimiert & Traces-Ansicht überarbeitet"
      },
      {
        type: "improvement",
        text: "HR-Admin-Filter: Die Mitarbeiterliste im Admin-Bereich filtert jetzt standardmäßig auf aktive Mitarbeiter"
      },
      {
        type: "bug",
        text: "Mehrere Fehler behoben: Zeichenkodierungsprobleme bei Datei-Anhängen (Support-Tickets, Fundsachen) beseitigt, Der Beleg-Upload akzeptiert jetzt auch nicht-standardisierte Dateiendungen, Im Angebots-Schritt 1 wurde ein duplizierter Block bereinigt, Validierungsfehler bei der Gruppenbuchung korrigiert & ein paar Fehler im Backend behoben."
      }
    ]
  },
  {
    version: "v1.5.7",
    date: "10. Juli 2026",
    title: "Support-Ticket Verbesserungen & Validierungs-Fix",
    changes: [
      {
        type: "improvement",
        text: "Support-Ticket Modal: 3-State-Filter (Alle/Eigene/Abteilung) für bessere Übersicht."
      },
      {
        type: "improvement",
        text: "Benachrichtigungen für Ticket-Ersteller: In-App- und Push-Benachrichtigungen bei Admin-Antworten."
      },
      {
        type: "bug",
        text: "Validierungs-Fix: Extras werden in Angebotserstellung jetzt erfolgreich hinzugefügt."
      }
    ]
  },
  {
    version: "v1.5.6",
    date: "07. Juli 2026",
    title: "Ordern-Upload und Bildervorschau",
    changes: [
      {
        type: "improvement",
        text: "Im Buchhaltungsmenü kann man jetzt gesamt Ordner hochladen, anstatt nur Dateien"
      },
      {
        type: "improvement",
        text: "IIn Traces und Fundsachen gibt es jetzt einen Button 'Vorschau', damit man Anhänge gesondert ansehen kann"
      }
    ]
  },
  {
    version: "v1.5.5",
    date: "03. Juli 2026",
    title: "UI Update für Gästeprofil",
    changes: [
      {
        type: "improvement",
        text: "Gästeprofilansicht wurde etwas überarbeitet"
      }
    ]
  },
  {
    version: "v1.5.4",
    date: "30. Juni 2026",
    title: "Angebotsraten überschreiben & Zeitsteuerung für Verfügbarkeiten",
    changes: [
      {
        type: "improvement",
        text: "Es ist jetzt möglich, Raten in einem Angebot zu überschreiben"
      },
      {
        type: "feature",
        text: "Es ist jetzt möglich, Verfügbarkeiten pro Standort über eine Zeitsteuerung zu sperren"
      }
    ]
  },
  {
    version: "v1.5.3",
    date: "29. Juni 2026",
    title: "Wartungsfenster in HSK-Liste",
    changes: [
      {
        type: "improvement",
        text: "Es ist jetzt für Admins möglich, Wartungsfenster nach Schlüsselwörter-Filter in die HSK-Liste einzublenden."
      },
      {
        type: "feature",
        text: "Es ist jetzt möglich, Individuelle KPI-Karten im Statistik-Tab zu konfigurieren und anzupinnen."
      },
      {
        type: "improvement",
        text: "Es gibt jetzt einen Datumsfilter für das Fälligkeitsdatumim Traces-Tab."
      },
      {
        type: "improvement",
        text: "Der Zimmerplan zeigt ab jetzt auch den Sauberkeitsstatus neben der Zimmernummer und es werden WEs und Feiertage im Zimmerplan angezeigt"
      }
    ]
  },
  {
    version: "v1.5.2",
    date: "27. Juni 2026",
    title: "Benachrichtigungs-Fix & Sperren-Duplizierung im Zimmerplan",
    changes: [
      {
        type: "bug",
        text: "Benachrichtigungen sollten wieder funktionieren"
      },
      {
        type: "bug",
        text: "Das Duplizieren von Sperren im Zimmerplan via Strg + Drag-Auswahl sollte jetzt wie gewohnt funktionieren"
      },
      {
        type: "bug",
        text: "Querformat ist wieder im Housekeeping-Menü zu sehen"
      }
    ]
  },
  {
    version: "v1.5.1",
    date: "22. Juni 2026",
    title: "UI-Update & Multi-Bestelldatum",
    changes: [
      {
        type: "improvement",
        text: "Kleines Interface-Update im Reservierungsmenü"
      },
      {
        type: "improvement",
        text: "Man kann jetzt mehrere Artikel in der Inventarliste auswählen und bei allen gleichzeitig das Bestelldatum ändern"
      }
    ]
  },
  {
    version: "v1.5.0",
    date: "21. Juni 2026",
    title: "Zimmerplan & Gruppenangebote",
    changes: [
      {
        type: "feature",
        text: "Eine Beta-Version des Zimmerplans wurde eingebaut. (s. 'Steuerung & Tastaturkürzel anzeigen' Helfer in dem Menü für Handhabung)"
      },
      {
        type: "feature",
        text: "Gruppenangebote sollten jetzt auch per Link von Gästen akzeptiert werden können"
      }
    ]
  },
  {
    version: "v1.4.9",
    date: "19. Juni 2026",
    title: "Inventar-Import & Reservierungssuche",
    changes: [
      {
        type: "feature",
        text: "Inventar Excel/CSV Import Wizard: Neue Bulk-Import-Funktion zum einfachen Hochladen von Inventarlisten. Neue Artikel werden angelegt und Bestände automatisch aktualisiert."
      },
      {
        type: "feature",
        text: "Letztes Bestelldatum: Neues Feld in der Inventarverwaltung, um Bestellungen noch besser nachverfolgen zu können."
      },
      {
        type: "improvement",
        text: "Smarte Reservierungssuche: Die Suchleiste findet Gäste jetzt auch bei teilweisen Namen, kombinierten Vor-/Nachnamen, E-Mails oder Telefonnummern."
      },
      {
        type: "improvement",
        text: "Housekeeping Druckansicht: Komplett überarbeitetes Layout für den Druck der Reinigungspläne. Spart Papier und hebt wichtige Stati (Bleiber, Abreise) klarer hervor."
      },
      {
        type: "improvement",
        text: "Automatischer Ablauf von Angeboten: Angebote wechseln nun automatisch in den Status 'Abgelaufen', sobald ihr Gültigkeitsdatum überschritten ist."
      },
      {
        type: "improvement",
        text: "Backend & Sicherheit: Umfangreiche Sicherheitsupdates, verbesserte Ladezeiten durch App Check Caching und stabilere Anmeldung."
      }
    ]
  },
  {
    version: "v1.4.8",
    date: "13. Juni 2026",
    title: "Multi-Tab-Unterstützung & System-Reload",
    changes: [
      {
        type: "bug",
        text: "Problem behoben, bei dem das Öffnen der App in einem neuen Tab den Benutzer in anderen Tabs abgemeldet hat."
      },
      {
        type: "improvement",
        text: "System-Updates (Seiten-Reloads) betreffen nun nur noch den jeweils aktiven Tab und stören andere offene Tabs nicht mehr."
      }
    ]
  },
  {
    version: "v1.4.7",
    date: "12. Juni 2026",
    title: "Sales&Revenue Suche & Housekeeping-Listen Optimierung",
    changes: [
      {
        type: "improvement",
        text: "Suchfeld im Sales&Revenue Menü eingebaut"
      },
      {
        type: "bug",
        text: "'Tag wählen' Warnung kommt in den Housekeeping-Listen ab jetzt ab 8 Tagen statt 7"
      },
      {
        type: "improvement",
        text: "Mehrere Erweiterungen im personalwesen hinzugefügt"
      },
      {
        type: "feature",
        text: "Service-Schnellbuchung Modul im Gruppen-Menü hinzugefügt"
      },
    ]
  },
  {
    version: "v1.4.6",
    date: "10. Juni 2026",
    title: "Mobile Filter-Header & Modals-Optimierungen",
    changes: [
      {
        type: "improvement",
        text: "Mobiler Filter-Header: Ein neuer Bottom Sheet Drawer klappt nun auf Mobilgeräten von unten hoch, um die Bedienung zu vereinfachen."
      },
      {
        type: "bug",
        text: "Modals im Vordergrund geöffnet: Fehler behoben, bei dem die 'Neuer Trace'- und 'Importieren'-Fenster auf Mobilgeräten im Hintergrund hinter dem Drawer geöffnet wurden."
      },
      {
        type: "improvement",
        text: "Farbe für mobile Buttons: Buttons wie 'Importieren', 'Neuer Trace' und 'Warteliste' im Header behalten nun auch auf Handys ihre richtigen Markenfarben anstatt schwarz-weiß zu werden."
      },
      {
        type: "improvement",
        text: "ALOS KPI bei Analytics hinzugefügt."
      },
      {
        type: "improvement",
        text: "Abruf von Reservierungen nach propertyId optimiert, um Leistungsprobleme zu vermeiden."
      }
    ]
  },
  {
    version: "v1.4.5",
    date: "9. Juni 2026",
    title: "Angebotsverwaltung mit Gast-Link & Apaleo-Buchung",
    changes: [
      {
        type: "feature",
        text: "Angebotsverwaltung: Erstelle Angebote ohne Buchung mit Zimmerkategorie-Auswahl, Firmenraten, manueller Preisangabe und internen Notizen."
      },
      {
        type: "feature",
        text: "Angebot per Link teilen: Versende Angebote direkt per Link – Gast kann ohne Konto das Angebot sehen und mit einem Klick buchen."
      },
      {
        type: "feature",
        text: "Angebot bestätigen → Buchung in Apaleo: Bestätigt der Gast das Angebot, wird automatisch eine Buchung in Apaleo erstellt."
      },
      {
        type: "feature",
        text: "Stornierungsbedingungen aus Ratenplan: Die Stornierungsbedingungen des gewählten Ratenplans werden automatisch im Angebot angezeigt."
      }
    ]
  },
  {
    version: "v1.4.4",
    date: "9. Juni 2026",
    title: "Gruppen- & Kontingentsverwaltung in Apaleo (Beta)",
    changes: [
      {
        type: "feature",
        text: "Beta-Version des Gruppen-Moduls: Einführung eines neuen Menüs für die Arbeit mit Gruppen und Kontingenten in Apaleo."
      },
      {
        type: "feature",
        text: "Zimmerkontingente & Excel-Import: Verwalte Zimmerblöcke und importiere Gästelisten direkt per Excel-Datei mit automatischer Datenprüfung."
      },
      {
        type: "feature",
        text: "Abrechnungs-Routings: Richte automatische Übertragungsregeln ein, um bestimmte Kosten (wie Übernachtungen) direkt auf Gruppen- oder Firmenrechnungen umzubuchen."
      }
    ]
  },
  {
    version: "v1.4.3",
    date: "9. Juni 2026",
    title: "Standortbezogene Inventarliste & Modals-Erweiterung",
    changes: [
      {
        type: "feature",
        text: "Standort-Filter für Inventar: Die Inventarverwaltung wurde um standortbezogene Listen und Statistiken erweitert. Abschlüsse und Bestände können jetzt separat pro Standort eingesehen und gepflegt werden."
      },
      {
        type: "improvement",
        text: "Erweiterung der Artikel-Modals: Beim Erstellen und Bearbeiten von Artikeln kann nun direkt der gewünschte Standort über ein Dropdown-Menü ausgewählt werden."
      }
    ]
  },
  {
    version: "v1.4.2",
    date: "8. Juni 2026",
    title: "Statistiken-Filter, Sales-Reports & Inventarverwaltung",
    changes: [
      {
        type: "feature",
        text: "Zimmernächte-KPI & Reisezeitraum-Filter: In der Buchungsstatistik wird nun die Summe der Netto-Zimmernächte angezeigt. Zudem visualisiert eine neue Karte die Verteilung der Buchungen auf zukünftige Monate, nach denen die gesamte Statistik und Liste per Klick oder Dropdown gefiltert werden kann."
      },
      {
        type: "feature",
        text: "Im Sales Menü gibt es nun Reports für Firmenumsatz und Ratenplan-Traffic pro Standort und Zimmerkategorie",
      },
      {
        type: "feature",
        text: "Neue Inventarverwaltung: Das Team kann nun Lagerbestände direkt in der App erfassen, per Schnell-Klick (+/-) anpassen, Bestellungen vorschlagen lassen, Einkaufslinks hinterlegen, CSV-Listen exportieren und Monatsabschlüsse archivieren.",
      },
    ]
  },
  {
    version: "v1.4.1",
    date: "7. Juni 2026",
    title: "Detaillierte Buchungsstatistiken & Fehlerbehebungen",
    changes: [
      {
        type: "feature",
        text: "Neue Buchungsstatistik-Ansicht unter Analytics: Visualisiert Buchungsquellen (Sources) in einem interaktiven Donut-Diagramm und listet Buchungen sowie Stornierungen detailliert mit Zimmernächten (RNs), ADR und Netto-ADR auf."
      },
      {
        type: "bug",
        text: "Fehler bei der Zählung von Stornierungen behoben: Abgelaufene oder stornierte Reservierungen werden nun korrekt anhand des 'Canceled'-Status aus der Apaleo API erkannt und im System verbucht."
      }
    ]
  },
  {
    version: "v1.4.0",
    date: "4. Juni 2026",
    title: "Start des B2C Gäste-Portals & Automatisierungen",
    changes: [
      {
        type: "feature",
        text: "Neues B2C Gäste-Portal: Gäste können sich ab sofort über ihr eigenes Portal einloggen, ihre Buchungshistorie (Stays) einsehen und geschlossene Rechnungen direkt als PDF herunterladen."
      },
      {
        type: "feature",
        text: "GoBD-konforme Rechnungskorrekturen: Gäste können fehlerhafte Rechnungen direkt im Portal zur Korrektur anmelden, neue Adressdaten hinterlegen und die gewünschte Sprache (Deutsch/Englisch) wählen."
      },
      {
        type: "feature",
        text: "Automatisierter Korrektur-Assistent: Das Team an der Rezeption kann angeforderte Adressänderungen mit nur einem Klick direkt in Apaleo umsetzen! Die App storniert die alte Rechnung, ändert die Folio-Adresse und erstellt die neue Rechnung vollautomatisch."
      },
      {
        type: "feature",
        text: "Integriertes Loyalty-Punkteprogramm: Gäste sammeln bei jedem Check-out automatisch Treuepunkte (0,25 Punkte pro 1€ Netto-Logisumsatz) und sehen ihren Punktestand live im Portal – inklusive rückwirkender Punkte-Gutschrift."
      },
      {
        type: "feature",
        text: "Textformatierung in Traces: Beim Bearbeiten von Traces stehen nun Klick-Buttons für Fettgedrucktes, Überschriften und Listen bereit. Zudem gibt es eine integrierte Vorschau-Ansicht für formatierte Texte."
      }
    ]
  },
  {
    version: "v1.3.9",
    date: "3. Juni 2026",
    title: "Support-System & Daten-Migration",
    changes: [
      {
        type: "feature",
        text: "Neues Support-System: Ihr könnt ab sofort Support-Tickets direkt in der App erstellen und einsehen! Ein Klick auf den neuen 'Support'-Button oben rechts öffnet das Service-Panel.",
      },
      {
        type: "improvement",
        text: "Daten-Migration abgeschlossen: Alle Einträge und Einstellungen wurden erfolgreich in das neue SaaS-System übertragen.",
      },
    ],
  },
  {
    version: "v1.3.8",
    date: "2. Juni 2026",
    title: "Plattform-Upgrade & Live-Updates",
    changes: [
      {
        type: "feature",
        text: "E-Mail-basierter Abgleich beim Login: Das Login über Apaleo sucht nun automatisch nach passenden Kontakten in unserem System per E-Mail-Adresse.",
      },
      {
        type: "feature",
        text: "Echtzeit-Zähler für Nachrichten: Die Anzahl ungelesener Nachrichten wird jetzt live direkt oben im Browser-Tab (Tab-Titel) angezeigt.",
      },
      {
        type: "bug",
        text: "Fehlerbehebung bei Traces: Traces, die für alle Abteilungen sichtbar sein sollen, werden nun wieder zuverlässig für alle erstellt.",
      },
      {
        type: "improvement",
        text: "Großes Plattform-Upgrade: Die Migration auf das neue Multi-Tenant-System (SaaS) wurde abgeschlossen. Dies sorgt für eine sicherere Trennung der Daten verschiedener Betriebe und stellt gleichzeitig die volle Kompatibilität mit der bisherigen Version sicher.",
      },
      {
        type: "improvement",
        text: "Fehlerbehebung Urlaubsverwaltung: Eine Endlosschleife im HR-Bereich, die zu Ladeverzögerungen führen konnte, wurde behoben.",
      },
      {
        type: "improvement",
        text: "Sicherheits-Patch & Stabilität: Mögliche Sicherheitslücken in Textvorschauen und Anleitungen wurden behoben sowie diverse Datenbank-Zugriffe abgesichert.",
      },
    ],
  },
  {
    version: "v1.3.7",
    date: "29. Mai 2026",
    title: "Kassenbuch-Updates",
    changes: [
      {
        type: "improvement",
        text: "Vollautomatische Kassenbuch-Erfassung: Wenn in Apaleo eine Rechnung erstellt wird und der Gast bar bezahlt hat, wird der Geldeingang jetzt automatisch im Kassenbuch eingetragen. Kein manuelles Nachtragen mehr nötig!",
      },
      {
        type: "improvement",
        text: "Erweitertes Formular & Einstellungen: Neues, geführtes Erfassungsmodal für manuelle Buchungen sowie ein Admin-Menü für Standardkonten und vordefinierte Buchungstexte.",
      },
      {
        type: "improvement",
        text: "Intelligente Safe-Erfassung: Geldbewegungen zwischen Kasse und Tresor werden automatisch als Einnahme oder Ausgabe erkannt und verbucht. Die Kassen- und Tresorbestände werden nun fehlerfrei berechnet.",
      },
    ],
  },
  {
    version: "v1.3.6",
    date: "28. Mai 2026",
    title: "Apaleo Echtzeit-Synchronisation & Namenskorrektur",
    changes: [
      {
        type: "feature",
        text: "Echtzeit-Synchronisation für das Housekeeping eingebaut: Zimmerstatus-Änderungen (sauber/schmutzig) von Apaleo aktualisieren sich nun ohne Neuladen vollautomatisch direkt auf dem Bildschirm.",
      },
      {
        type: "feature",
        text: "Echtzeit-Synchronisation für die Haustechnik (Wartungsfenster) hinzugefügt, sodass neue oder geänderte Wartungsblocks sofort auftauchen.",
      },
      {
        type: "improvement",
        text: "Automatisches Gästekartei-Cleanup von d-edge/Booking.com Namen - Korrigiert jetzt Buchungen, bei denen der Vorname komplett leer übergeben und stattdessen mit in das Nachnamenfeld geschrieben wurde.",
      },
    ],
  },
  {
    version: "v1.3.5",
    date: "27. Mai 2026",
    title: "Extrabetten Traces & Anschlussbuchungen",
    changes: [
      {
        type: "feature",
        text: "Neuer Filter und Highlighting für Anschlussbuchungen sichtbar im Reservierungsmenü",
      },
      {
        type: "feature",
        text: "Extrabetten & Babybetten für die Anreisen der nächsten zwei Tage, bekommen jetzt auto. Traces dazu erstellt",
      },
      {
        type: "feature",
        text: "Eine Beta-Version von einem Modul für die Erstellung von Xrechnungen wurde eingebaut",
      },
      {
        type: "improvement",
        text: "Man kann jetzt die Personenzahl der Reservierungen in der Housekeepingliste sehen",
      },
      {
        type: "bug",
        text: "Warteliste sucht jetzt korrekt nach den Verfügbarkeiten",
      },
      {
        type: "improvement",
        text: "Man kann jetzt in seinen Benachrichtigungen nach Text suchen und Einträge löschen",
      },
    ],
  },
  {
    version: "v1.3.4",
    date: "22. Mai 2026",
    title: "Anleitungsmenü, auto. Sperren & Fixes",
    changes: [
      {
        type: "improvement",
        text: "Benachrichtigungen werden jetzt automatisch an zugewiesene Personen gesendet, wenn ein neuer Kommentar bei einem Trace oder einer Fundsache geschrieben wird (auch ohne direkte Erwähnung).",
      },
      {
        type: "bug",
        text: "Fehlerhafte Cursor-Position bei der Auswahl von Kollegen im Fundsachen-Chat korrigiert.",
      },
      {
        type: "bug",
        text: "Doppelte Push-Benachrichtigungen im Hintergrund behoben, sodass jetzt nur noch eine Benachrichtigung angezeigt wird.",
      },
      {
        type: "feature",
        text: "Ein Modal wurde im Reservierungsmenü hinzugefügt, um Sperren in engen Zeiträumen automatisch zu erstellen, sobald ein Zimmer frei werden sollte.",
      },
      {
        type: "bug",
        text: "Darstellungsfehler behoben: Der Standort-Filter im Fundsachen-Archiv (V2) klappt jetzt vollständig auf und wird nicht mehr abgeschnitten.",
      },
      {
        type: "feature",
        text: "Importieren von einer Excel-Liste für Traces ist jetzt möglich.",
      },
      {
        type: "bug",
        text: "Aktivitätenverlauf bei den Traces repariert: Alle Aktionen werden jetzt wieder im Log-Tab aufgezeichnet.",
      },
      {
        type: "feature",
        text: "Ein 'Anleitung' Menü wurde hinzugefügt, wo man Dateien, Links und Texte erstellen/hochladen kann.",
      },
      {
        type: "feature",
        text: "Neuer Button 'Jahreswechsel durchführen' für Admins in der Urlaubsverwaltung: Überträgt den Resturlaub sicher ins neue Jahr und richtet den Urlaubsanspruch aller Mitarbeiter gleichzeitig ein – inklusive einer praktischen Vorschau und Sicherheitswarnungen.",
      },
      {
        type: "feature",
        text: "Belege (wie Kassenzettel oder Rechnungen) können nun direkt bei den Einträgen im Kassenbuch hochgeladen und aufgerufen werden. Einträge ohne hochgeladenen Beleg werden mit einem blinkenden roten Hinweis markiert. Tresorbestand wurde ebenfalls hinzugefügt",
      },
    ],
  },
  {
    version: "v1.3.3",
    date: "20. Mai 2026",
    title: "Benachrichtigungen auf PC und Handy",
    changes: [
      {
        type: "feature",
        text: "Man kann jetzt Benachrichtigungen auf PC und Handy via Chrome Browser bekommen, wenn man dies in den Einstellungen erlaubt hat.",
      },
    ],
  },
  {
    version: "v1.3.2",
    date: "18. Mai 2026",
    title: "Filter-Buttons im Trace Menü gefixt",
    changes: [
      {
        type: "bug",
        text: "Habe beim Trace-Menü die Filter-Buttons für 'Abteilung offen' und 'Abteilung Fällig' gefixt. Diese haben vorher die Abteilung des Users nicht richtig erkannt",
      },
      {
        type: "improvement",
        text: "Habe ein paar Sicherheitslücken im System geschlossen",
      },
    ],
  },
  {
    version: "v1.3.1",
    date: "17. Mai 2026",
    title: "Auto-Zuweisung von Wunschzimmern",
    changes: [
      {
        type: "feature",
        text: "Man kann im Gastprofil nun das Wunschzimmer eines Gastes festlegen und es wird dann bei der nächsten Reservierung automatisch zugewiesen, insofern verfügbar",
      },
      {
        type: "bug",
        text: "Habe beim Buchungsmodul einen visuellen Bug behoben",
      },
      {
        type: "improvement",
        text: "Sicherheits-Patch: Benachrichtigungsregeln in der Datenbank abgesichert, um unautorisierte Zugriffe zu unterbinden",
      },
    ],
  },
  {
    version: "v1.3.0",
    date: "16. Mai 2026",
    title: "Kassenbuch & Wiederkehrende Traces",
    changes: [
      {
        type: "feature",
        text: "Kassenbuch-Modul finalisiert, inkl. Standortauswahl, Excel-Export, Kassenzähler und Änderungsprotokoll",
      },
      {
        type: "feature",
        text: "Man kann jetzt in seinem Profil oben rechts (bzw. Präferenzen-Menü unten links auf mobiler Ansicht) die Menüs in der Seitenleiste gruppieren",
      },
      {
        type: "feature",
        text: "Man kann jetzt wiederkehrende Traces erstellen, die sich täglich, wöchentlich oder monatlich wiederholen (max. 50 mal)",
      },
      {
        type: "improvement",
        text: "Habe die Abteilung 'Interne Ressourcen' für Traces für RA&DS hinzugefügt",
      },
    ],
  },
  {
    version: "v1.2.9",
    date: "15. Mai 2026",
    title: "Reservierungs-Menü Update",
    changes: [
      {
        type: "bug",
        text: "Behebung des UI-Fehlers, der verhinderte, dass die neue Ansicht auf Mobilgeräten angezeigt wurde.",
      },
      {
        type: "improvement",
        text: "Man kann jetzt CRM-Status im Gastprofil per Klick wieder deaktivieren",
      },
      {
        type: "improvement",
        text: "Der Kopf im Reservierungsmenü ist nicht mehr so riesig, was mehr Platz für die Ansicht schafft",
      },
      {
        type: "improvement",
        text: "Man sieht die Gesamtzahl der Aufenthalte eines Gastes in seinem Profil oben neben dem Namen",
      },
      {
        type: "feature",
        text: "Beta-Version eines Kassenbuches erstellt (zurzeit nur für Admins nutzbar)",
      },
    ],
  },
  {
    version: "v1.2.8",
    date: "14. Mai 2026",
    title: "Synchronisation & Stabilität",
    changes: [
      {
        type: "feature",
        text: "Klickbare Karten: Es gibt jetzt vier Karten oben in den Traces, die als Schnellfilter für Traces dienen.",
      },
      {
        type: "improvement",
        text: "Die Suchleisten wurden schicker gemacht und brauchen jetzt weniger Platz.",
      },
      {
        type: "improvement",
        text: "Die Filterbalken am Handy wurden überarbeitet, damit nichts mehr gequetscht aussieht.",
      },
      {
        type: "bug",
        text: "Ein paar kaputte Symbole bei den Fundsachen repariert und das Housekeeping-Dashboard stabilisiert.",
      },
      {
        type: "feature",
        text: "Das gesamte System wurde von 'Tasks/Aufgaben' auf 'Traces' umgestellt, inklusive neuer Datenbank-Struktur.",
      },
      {
        type: "improvement",
        text: "Daten-Migration: Alle bestehenden Aufgaben wurden erfolgreich in das neue Trace-System migriert.",
      },
      {
        type: "feature",
        text: "Ihr könnt nun oben rechts auf euer Profil klicken (auf dem Handy in der Seitenleiste) und eine Standort-Präferenz festlegen, sodass das System direkt mit dem/den richtigen Standort(en) filtert.",
      },
      {
        type: "feature",
        text: "Housekeeping-Forecast in neuem Tab im Housekeeping-Menü hinzugefügt",
      },
    ],
  },
  {
    version: "v1.2.7",
    date: "13. Mai 2026",
    title: "Update in Fundsachen & Reservierungen",
    changes: [
      {
        type: "feature",
        text: "Fundsachen-Chat: Ab sofort können Kollegen direkt per @Name markiert und benachrichtigt werden, wie bei den Traces auch schon.",
      },
      {
        type: "feature",
        text: "Schnell-Navigation: Ein Klick auf Benachrichtigungen öffnet nun direkt den passenden Trace *oder* Fundsache.",
      },
      {
        type: "feature",
        text: "Gästekartei: Reinigungstage lassen sich jetzt direkt in der Kartei festlegen.",
      },
      {
        type: "feature",
        text: "Reservierungen: Neue Spalten für Standort und Reinigung in der Liste.",
      },
      {
        type: "feature",
        text: "Traces: Zuweisung an mehrere Personen gleichzeitig sowie ein neues 'Melder'-Feld hinzugefügt.",
      },
      {
        type: "improvement",
        text: "System: Die Nutzer-Vorschläge wurden systemweit auf Vornamen vereinheitlicht.",
      },
      {
        type: "improvement",
        text: "Synchronisation: Live-Abgleich der Reinigungstage zwischen Housekeeping und Reservierungen.",
      },
      {
        type: "improvement",
        text: "UI: Optimierte Darstellung der Dropdowns und Namen für eine bessere Lesbarkeit.",
      },
      {
        type: "improvement",
        text: "Filter: Standort-Filter bei den Fundsachen ergänzt.",
      },
      {
        type: "bug",
        text: "Fix: Korrekte Darstellung der Symbole in der Gästekartei wiederhergestellt.",
      },
    ],
  },
  {
    version: "v1.2.4",
    date: "12. Mai 2026",
    title: "Interface-Update & Warteliste",
    changes: [
      {
        type: "feature",
        text: "Warteliste-Modul: Automatisierte Überprüfung der Zimmerverfügbarkeit alle 10 Minuten.",
      },
      {
        type: "feature",
        text: "SmartHost-Integration: Neuer Button für die direkte Weiterleitung zur Angebotserstellung.",
      },
      {
        type: "feature",
        text: "Interface-Update: Einführung eines modernen Designs (v2) neben der klassischen Ansicht, umschaltbar per Klick unten links über das Seitenmenü ('UI: Modern v2').",
      },
    ],
  },
  {
    version: "v1.2.3",
    date: "06. Mai 2026",
    title: "Housekeeping-Ansicht Update",
    changes: [
      {
        type: "feature",
        text: "Housekeeping: Zimmerstatus (Sauber, Schmutzig, Inspektion) werden nun geladen und dargestellt.",
      },
      {
        type: "feature",
        text: "Housekeeping: Turnover-Zimmer zeigen nun Abreise und Anreise an.",
      },
      {
        type: "improvement",
        text: "Housekeeping: Bei 'Bleibern' werden ab sofort nur noch Zimmer angezeigt, die auch für den jeweiligen Wochentag zur Reinigung vorgesehen sind.",
      },
      {
        type: "improvement",
        text: "Housekeeping: Bereits abgereiste Gäste (Checked Out) und angereiste Gäste (InHouse) bleiben auf den relevanten Listen sichtbar.",
      },
      {
        type: "improvement",
        text: "Housekeeping: Die Filter-Logik wurde vereinfacht, um alle Ansichten (Abreise, Anreise, Turnover) flexibler auch für Daten in der Zukunft nutzbar zu machen.",
      },
    ],
  },
  {
    version: "v1.2.2",
    date: "06. Mai 2026",
    title: "Mobile Optimierung",
    changes: [
      {
        type: "improvement",
        text: "Mobile-Optimierung: Einige Hauptmenüs (HR, Fundsachen, Haustechnik) wurden für Smartphones optimiert.",
      },
    ],
  },
  {
    version: "v1.2.1",
    date: "05. Mai 2026",
    title: "Interface Optimierung & Angebot-Button",
    changes: [
      {
        type: "bug",
        text: "Behebung eines Fehlers, bei dem neu registrierte Benutzer nicht im Nutzerverwaltung-Dashboard angezeigt wurden.",
      },
      {
        type: "feature",
        text: "Neue 'Anreisetag' und 'Abreisetag' Schnellauswahl-Buttons für Datumsfelder in allen Trace-Ansichten hinzugefügt.",
      },
      {
        type: "feature",
        text: "Button eingerichtet im Reservierungs-Menü 'Angebot via Smarthost erstellen' für eine schnelle Weiterleitung",
      },
      {
        type: "improvement",
        text: "Das angezeigte Datumsformat in Eingabefeldern wurde systemweit auf ein einheitliches Format (DD.MM.YY) umgestellt.",
      },
    ],
  },
  {
    version: "v1.2.0",
    date: "04. Mai 2026",
    title: "Haustechnik-Powerup & System-Optimierung",
    changes: [
      {
        type: "improvement",
        text: "Zimmer-Listen: Die Tabs 'Freie Zimmer' und 'Zimmercheck' laden jetzt echte Daten direkt aus Apaleo.",
      },
      {
        type: "feature",
        text: "Wartungs-Update: Neue Suchfunktion, bessere Sortierung und automatische Status-Erkennung für Wartungsfenster.",
      },
      {
        type: "feature",
        text: "Status-Badges: Bei freien Zimmern wird jetzt angezeigt, ob heute eine An- oder Abreise ansteht.",
      },
      {
        type: "improvement",
        text: "Stabilität: Großer 'Hausputz' im Hintergrund für schnellere Ladezeiten.",
      },
      {
        type: "bug",
        text: "Büroklammer-Fix: Anhänge in Traces lassen sich nun wieder ohne Absturz öffnen.",
      },
      {
        type: "bug",
        text: "Anzeigefehler bei den Statistiken und der Zeiterfassung im HR-Bereich korrigiert.",
      },
    ],
  },
  {
    version: "v1.1.9",
    date: "02. Mai 2026",
    title: "Mobile Optimierung",
    changes: [
      { type: "improvement", text: "Design für Mobilgeräte verbessert." },
    ],
  },

  {
    version: "v1.1.8",
    date: "01. Mai 2026",
    title: "Haustechnik-Modul fast fertig",
    changes: [
      {
        type: "improvement",
        text: "Manueller Pausebutton neben dem Korrigierenbutton hinzugefügt",
      },
      {
        type: "bug",
        text: "Behebung eines Login-Fehlers durch ein Update des Providers",
      },
      { type: "feature", text: "Fundsachen-Menü hinzugefügt" },
      { type: "improvement", text: "Suchfeld oberhalb der Traces hinzugefügt" },
      { type: "feature", text: "Hausdame and HT-Leitung Rollen hinzugefügt" },
      {
        type: "feature",
        text: "Habe heute das Haustechnik-Modul fast fertig gestellt",
      },
    ],
  },
  {
    version: "v1.1.7",
    date: "30. April 2026",
    title: "auto. Traces via Reservierung verbessert",
    changes: [
      {
        type: "improvement",
        text: "Bei der Erstellung von Traces via Reservierungsbutton, kann jetzt die Abteilung direkt ausgewählt werden und es steht auch im Aktivitätenfeed",
      },
      {
        type: "improvement",
        text: "Stornierungsbedingungen sind jetzt direkt sichtbar nach einer Reservierung",
      },
      {
        type: "improvement",
        text: "Gibt jetzt ein Feld für Zimmernummern in Traces, welche mit Apaleo synchronisiert werden",
      },
      {
        type: "improvement",
        text: "Auto. Löschen von Traces, deren verknüpfte Reservierung in Apaleo storniert wurde",
      },
    ],
  },
  {
    version: "v1.1.6",
    date: "29. April 2026",
    title: "Login Verbessert",
    changes: [
      {
        type: "improvement",
        text: "Habe heute den Login-Bereich neu konfiguriert, dass ReCaptcha nicht mehr stört und 2FA via Mail existiert.",
      },
    ],
  },
  {
    version: "v1.1.5",
    date: "23. April 2026",
    title: "Update für Gästekartei und Stempelfunktion",
    changes: [
      {
        type: "improvement",
        text: "Habe einen Prototypen einer Reservierungszusammenfassung in der Gästekartei eingebaut",
      },
      {
        type: "improvement",
        text: "Wenn man sich gestern vergessen hat auszustempeln, wird man ab jetzt am nächsten Tag aufgefordert dies  nachzutragen",
      },
    ],
  },
  {
    version: "v1.1.4",
    date: "22. April 2026",
    title: "Buchungs und Gästekartei Modal",
    changes: [
      {
        type: "feature",
        text: "Es gibt jetzt einen Buchungs-Button über der Resservierungsliste",
      },
      {
        type: "feature",
        text: "Es gibt jetzt eine Gästekartei mit Status, Firmenraten-Verknüpfung und interner Notiz und der Möglichkeit direkt aus der Kartei eine Buchung zu erstellen",
      },
      {
        type: "feature",
        text: "Wenn ein Gast eine Firmenrate hat, wird diese direkt angezeigt bei einer neuen Buchung",
      },
      {
        type: "feature",
        text: "Wenn ein Gast auf Blacklist steht, kann keine Buchung erstellt werden",
      },
      {
        type: "feature",
        text: "Wenn ein Gast eine Interne Notiz hat, kann per Häkchen direkt ein Trace für Anreisetag erstellt werden",
      },
    ],
  },
  {
    version: "v1.1.3",
    date: "15. April 2026",
    title: "Interface-Update im Trace-Menü",
    changes: [
      { type: "improvement", text: "Überfällige Traces sind jetzt pregnanter" },
      {
        type: "improvement",
        text: "Die Filter sind jetzt oben an die Liste geklebt un bleiben fixiert beim scrollen",
      },
      {
        type: "improvement",
        text: "Neue Trace erstellen ist jetzt hinter einem Button",
      },
    ],
  },
  {
    version: "v1.1.2",
    date: "13. April 2026",
    title: "Trace-Menü Verbesserungen",
    changes: [
      { type: "improvement", text: "Man kann jetzt Dateien anhängen" },
      {
        type: "feature",
        text: "Es gibt jetzt ein Kommentar- und Aktivitätenfeed",
      },
      {
        type: "feature",
        text: "Es gibt oben rechts eine Glocke, um zu sehen, ob man neue Nachrichten hat sowie eine Historie dort",
      },
    ],
  },
  {
    version: "v1.1.1",
    date: "07. April 2026",
    title: "HR Features",
    changes: [
      {
        type: "feature",
        text: 'Mein Verlauf" Menü for jeden Benutzer im HR Modul hinzugefügt',
      },
      {
        type: "feature",
        text: "einen Prototypen einer Adminansicht ebenfalls hinzugefügt",
      },
    ],
  },
  {
    version: "v1.1.0",
    date: "02. April 2026",
    title: "Initial Launch",
    changes: [
      { type: "feature", text: "Adapt Hub offiziell gestartet." },
      {
        type: "feature",
        text: "Modul-System für Dashboard, Analytics, Traces, Sales, Housekeeping und HR.",
      },
      { type: "feature", text: "Profil merging hinzugefügt" },
    ],
  },
];
